import { FlowComponentCategory, FlowComponentDefinition, FlowComponentType } from "../../interface/functionalityInterface";
import { ballValveComponent } from "./ballValve";
import { bendComponent } from "./bend";
import { diaphragmValveComponent } from "./diaphragmValve";
import { heatExchangerComponent } from "./heatExchanger";
import { pipeComponent } from "./pipe";
import { pumpComponent } from "./pump";
import { tankComponent } from "./tank";
import { tPipeComponent } from "./tPipe";
import { triClampComponent } from "./triClamp";

export const FLOW_COMPONENT_DEFINITIONS: FlowComponentDefinition[] = [
  pipeComponent,
  bendComponent,
  triClampComponent,
  ballValveComponent,
  diaphragmValveComponent,
  tPipeComponent,
  heatExchangerComponent,
  pumpComponent,
  tankComponent,
];

export const FLOW_COMPONENT_MAP = new Map<FlowComponentType, FlowComponentDefinition>(
  FLOW_COMPONENT_DEFINITIONS.map((component) => [component.type, component])
);

export const getFlowComponentDefinition = (type: FlowComponentType) =>
  FLOW_COMPONENT_MAP.get(type)!;

export const FLOW_COMPONENT_SECTIONS: {
  key: string;
  title: FlowComponentCategory;
  components: FlowComponentDefinition[];
}[] = ["Pipes & Fittings", "Connections", "Valves", "Equipment"].map((category) => ({
  key: category.toLowerCase().replace(/[^a-z]+/g, "-"),
  title: category as FlowComponentCategory,
  components: FLOW_COMPONENT_DEFINITIONS.filter(
    (component) => component.category === category
  ),
}));
